/**
 * CRM Contract Detail New - Detalle de contrato para agentes (new)
 * Ruta: /crm/contratos-new/:code
 * Reutiliza AdminContractDetail con contractsListPath para navegación correcta
 */
import { AdminContractDetail } from '@/pages/admin/AdminContractDetail';

export function CRMContractDetailNew() {
  return <AdminContractDetail contractsListPath="/crm/contratos-new" />;
}
